import { createElement } from 'react';
import { useDefaultComponentValue } from '../../../../utils/useDefaultComponentValue';
import { TextField } from '../../TextField';
import textFieldComposer from '../../TextFieldComposer';
const COMPONENT_NAME = 'SimpleTextField';
const SimpleTextField = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    return /*#__PURE__*/ createElement(TextField, {
        ...props,
        simple: true
    });
};
const composedSimpleTextFieldWithoutValidations = textFieldComposer(SimpleTextField, false);
export { SimpleTextField, composedSimpleTextFieldWithoutValidations };
export default textFieldComposer(SimpleTextField);
